<template>
  <tr>
    <td class="text-center">
      <a class="small interactive-cursor text-info" @click="editIcon()">
      <img
        class="db-icon-img" 
        :src="reportType.AppIcon ? 'https://s3-ap-southeast-2.amazonaws.com/roscon/' + reportType.AppIcon.objectKey : require('../../assets/appicons/placeholder.jpg')" 
        :alt="reportType.name + ' icon'" />
        <br/>
        [ Change ]
        </a>
    </td>
    <td data-label="Report">
      <strong>
        {{ reportType.name }}
      </strong>
    </td>
    <td class="button-2 text-center">
    <button class="btn btn-indigo" @click="editReportType()">
      <i class="fa fa-edit"></i> Edit
    </button>
    <button v-if="reportType.QuoteCostings.length" class="btn btn-primary" @click="editPricing()">
      <i class="fa fa-dollar-sign"></i> Pricing
    </button>
    <button v-else class="btn btn-info" @click="addPricing()">
      <i class="fa fa-plus"></i> Add Pricing
    </button>
    <button class="my-3 btn btn-danger" @click="deleteReportType()">
        <i class="fa fa-trash" /> Delete
      </button>
    </td>
  </tr>
</template>

<script>
  import {
    UPLOAD_REPORT_ICON,
    EDIT_REPORT_PRICING,
    ADD_REPORT_PRICING
  } from '@/vuex/types'
  export default {
    name: 'ReportTypeRow',
    props: {
      object: {
        type: Object
      }
    },
    computed: {
      reportType () {
        return {
          QuoteCostings: [],
          ...this.object
        }
      }
    },
    methods: {
      editReportType () {
        this.$emit('edit', { permalink: 'editReportType', uuid: this.reportType.uuid })
      },
      async editIcon () {
        await this.$store.dispatch(UPLOAD_REPORT_ICON, this.reportType.uuid)
      },
      async editPricing () {
        await this.$store.dispatch(EDIT_REPORT_PRICING, this.reportType.uuid)
      },
      async addPricing () {
        await this.$store.dispatch(ADD_REPORT_PRICING, this.reportType.uuid)
      },
      deleteReportType () {
        this.$emit('deleteObject', { permalink: 'deleteReportType', uuid: this.reportType.uuid })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/rows/ReportType.vue